import {
  alias,
  deserialize,
  list,
  object,
  optional,
  serializable,
} from 'serializr';

class BugzillaBaseItemContextModel {
  @serializable
  public id: number;
  @serializable
  public name: string;

  deserialize(input: any): this {
    return Object.assign(
      this,
      deserialize(BugzillaBaseItemContextModel, input),
    );
  }
}

export class BugzillaProjectIssueTypeModel extends BugzillaBaseItemContextModel {}

export class BugzillaProjectVersionModel extends BugzillaBaseItemContextModel {}

export class BugzillaProjectModel extends BugzillaBaseItemContextModel {
  @serializable(
    alias('components', list(optional(object(BugzillaProjectIssueTypeModel)))),
  )
  public issueTypes: BugzillaProjectIssueTypeModel[];
  @serializable(list(optional(object(BugzillaProjectVersionModel))))
  public versions: BugzillaProjectVersionModel[];
}
